import React from "react";
import DefaultEditor from "react-simple-wysiwyg";

const TextEditor = ({ description, onChange, height }) => {
  // Normalize to string to prevent crashes when non-string values are passed
  const safeDescription = (description !== null && description !== undefined && typeof description !== 'object')
    ? String(description)
    : "";

  let values = safeDescription;

  if (safeDescription.includes("<div") || safeDescription.includes("<p") || safeDescription.includes("<ul") || safeDescription.includes("<li")) {
    values = safeDescription;
  } else {
    // Legacy logic for bullet points with '*' or '/n'
    const aboutUsList =
      safeDescription !== ""
        ? safeDescription.includes("/n")
          ? safeDescription.includes("/n,")
            ? safeDescription.split("/n,")
            : safeDescription.split("/n")
          : safeDescription.split("*")
        : [];
    
    if (Array.isArray(aboutUsList) && aboutUsList.length) {
      // Filter out empty strings to avoid empty paragraphs
      const validLines = aboutUsList.filter(line => line.trim() !== "");
      if (validLines.length > 0) {
          const formattedDescription = validLines.map((line) => `<p>${line.trim()}</p>`).join("");
          values = formattedDescription;
      } else {
          values = "";
      }
    } else {
      values = safeDescription;
    }
  }
  return (
    <div id="summernote">
      <DefaultEditor
        value={values}
        onChange={(e) => onChange(e.target.value)}
        containerProps={{ style: { height: height } }}
      />
    </div>
  );
};

export default TextEditor;
